module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"create-courier-map":"Create Courier map","courier-map-created":"Courier map created","failed-create-courier-map":"Failed to create courier map"}}')
  delete Component.options._Ctor
}
